import { Dimensions } from 'react-native';
export const windowWidth = Dimensions.get('window').width;
export const windowHeight = Dimensions.get('window').height;

// //export const API_URL = Platform.OS === 'ios' ? 'http://192.168.111.213:5432' : 'http://192.168.111.213:5432';
// export const API_URL = Platform.OS === 'ios' ? 'https://ec2-18-117-55-156.us-east-2.compute.amazonaws.com:80' : 'https://ec2-18-117-55-156.us-east-2.compute.amazonaws.com:80';
// export const SOCKET_URL = 'https://cityparty-socket.herokuapp.com';
// export const ACCESSTOKEN_KEY = "@RaiseYourVoiceAT:2021";
// export const REFRESHTOKEN_KEY = "@RaiseYourVoiceRT:2021";
// export const TUTORIAL_CHECK = "tutorial";